export default __webpack_public_path__ + "static/media/arrow_drop_down_blue.78d4546e.svg";